import React from 'react';
import styled from 'styled-components';
import { rem } from '@/client/public/styledComponent/global';

const Container = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background: #000;
  color: #fff;

  .text {
    font-size: ${rem(28)};
    font-family: Roboto-Regular;
    color: #939393;
    padding-bottom: 10vh;
  }

  //opacity: 0.5;
`;

const Error = ({ tip }: { tip: string }) => {
  return (
    <Container>
      <div className="text">{tip}</div>
    </Container>
  );
};

export default Error;
